import React from 'react';
import config from 'react-global-configuration';

import { APPELTJES_DOMAIN, MAATJES_DOMAIN, NLDOET_DOMAIN } from '../../config/constants';

import FooterFull from './Full';
import FooterCampaign from './Campaign';
import GenericFooter from './Generic';
import MaatjesFooter from './Maatjes';


import './style.scss';

const Footer = ({ variant, campaignEntity }) => {
  const currentDomain = config.get('CURRENT_DOMAIN');

  // Domain‑specific footer
  const domainMap = {
    [MAATJES_DOMAIN]: <MaatjesFooter />,
    [APPELTJES_DOMAIN]: <GenericFooter />,
    [NLDOET_DOMAIN]: <GenericFooter />,
  };
  if (domainMap[currentDomain]) return domainMap[currentDomain];

  // Variant‑specific footer
  const variantMap = {
    campaign: <FooterCampaign campaignEntity={campaignEntity} />,
    privacy: <></>,
  };
  return variantMap[variant] ?? <FooterFull />; // Default fallback
};

export default Footer;
